import * as Axios from "axios";

import config from "@/config";
import router from "@/router";
import store from "@/store/index";
import { Message } from "element-ui";
import cookie from "js-cookie";
// import { removeInfo } from '@/utils';

const baseURL =
  process.env.NODE_ENV === "development"
    ? config.basicUrl
    : `${location.origin}/`;
const axios = Axios.default.create({
  baseURL: config.basicUrl, // api请求的baseURL
  timeout: 20000,
  // withCredentials: true, // 允许跨域 cookie
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    ClientType: "PC",
    "Content-Type": "application/x-www-form-urlencoded",
  },
  maxContentLength: 2000,
  transformResponse: [
    (data) => {
      try {
        data = JSON.parse(data);
      } catch (e) {
        data = {};
      }
      if (data.status === 403||data.code === 20003) {
        // removeInfo();
        router.push("/login");
      }

      return data;
    },
  ],
});
let messageInstance: any = null;
const mainMessage: any = (options: any) => {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(options);
};
const arr: any = ["success", "warning", "info", "error"];

arr.forEach((type: any) => {
  mainMessage[type] = (options: any) => {
    if (typeof options === "string") {
      options = { message: options };
    }
    options.type = type;
    return mainMessage(options);
  };
});
// 添加请求拦截器
axios.interceptors.request.use(
  (config: any) => {
    let token: any = "";
    const tokenGet = cookie.get("accessToken");
    const url_ = window.location.href;
    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date().toString()) / 1000,
        ...config.params,
      };
    }
    const tokenList = [
      "/login",
      "/pcm/",
      "/unit/",
      "/person/",
      "/apply/",
      "/detail/",
      "/declare",
    ];
    // 需要加token的网址
    if (config.url.includes("/login")) {
      config.headers["accessToken"] = null;
    } else {
      tokenList.find((url: any) => {
        if (url_.includes(url) && tokenGet && !config.headers["accessToken"]) {
          // set request header
          config.headers["accessToken"] = tokenGet;
          // set token for IE9 compatible
          token = tokenGet;
        }
      });
    }
    // deal with token for compatible IE9
    const browser = navigator.appName;
    const bVersion = navigator.appVersion;
    if (bVersion.indexOf(";") < 0) {
      return config;
    }
    const version = bVersion.split(";");
    const trimVersion = version[1].replace(/[ ]/g, "");
    if (browser == "Microsoft Internet Explorer" && trimVersion == "MSIE9.0") {
      if (config.url.indexOf("?") > 0) {
        config.url = config.url + "&accessToken=" + JSON.parse(token).value;
      } else {
        config.url = config.url + "?accessToken=" + JSON.parse(token).value;
      }
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

//添加响应拦截器
axios.interceptors.response.use(
  (response: any) => {
    /* if (response && response.data && response.data.message) {
      const msgString = response.data.message;
      const code = response.data.code;

      if (
        msgString == "Token异常,请重新登录" ||
        msgString == "token过期请重新登录" ||
        code == 403
      ) {
        clearAllStorage();
        logOut(response.data.message);
      } else if (code !== 200) {
        mainMessage.error(response.data.message);
      }
    } */
    // checkIsReLoad();
    // if(response.data.code < 0) {
    //   mainMessage.error('服务器异常,请稍后重试');
    //   return response;
    // }
    return response;
  },
  (error: any) => {
    // 返回状态码不为200时候的错误处理
    if (error.response) {
      if (error.response.status === 403) {
        clearAllStorage();
        logOut(error.data.message);
      } else {
        // 其他错误处理
        mainMessage.error(error.response.data.message);
      }
    }
    /* router.push("/login") */
    return Promise.resolve(error);
  }
);
function logOut(msg: any) {
  //跳转至登陆页面
  const href: any = window.location.href;

  if (
    href.indexOf("/unit/") >= 0 ||
    href.indexOf("/person/") >= 0 ||
    href.indexOf("/apply/") >= 0
  ) {
    mainMessage.error(msg);
    router.push({ path: "/login" });
  } else {
    // mainMessage.error("您尚未登录，请登录账户!");
  }
}
function clearAllStorage() {
  //清空缓存
  store.commit("account/clearToken");
  store.commit("setBasic");
  store.commit("setRoleBasic");
}
// get
export const _get = (req: any) => {
  return axios.get(req.url, { params: req.data });
};

// post
export const _post = (req: any) => {
  return axios({ method: "post", url: `/${req.url}`, data: req.data });
};
// postParams
export const _postParams = (req: any) => {
  return axios({ method: "post", url: `/${req.url}`, params: req.data });
};
// patch
export const _put = (req: any) => {
  return axios({ method: "put", url: `/${req.url}`, data: req.data });
};
export const _putParams = (req: any) => {
  return axios({ method: "put", url: `/${req.url}`, params: req.data });
};
// delete
export const _delete = (req: any) => {
  return axios({ method: "delete", url: `/${req.url}`, data: req.data });
};
// patch
export const _patch = (req: any) => {
  return axios({ method: "patch", url: `/${req.url}`, data: req.data });
};
export default axios;
